import { Modal, Button, Table } from 'react-bootstrap';
import { IVoucherHolder } from '@nkr/models/action-center/voucher-donor';
import { IDonorCompliance } from '@nkr/models/donor-compliance';
import { VoucherHolderSelfRegistrationStep, VoucherHolderType } from '@nkr/enums/index';

interface IProps {
    show: boolean,
    adpVoucherHolders: IVoucherHolder[],
    exportabilityResults: any[],
    donorCompliance: IDonorCompliance,
    type: number,
    onCancel: () => void
}

const NotificationDetails = (props: IProps) => {
    if (props.adpVoucherHolders == null && props.show == false)
        return null;

    if (props.type == 1) {
        return (
            <>
                <Modal show={props.show} onHide={() => null} style={{ zIndex: 999999 }}>
                    <Modal.Header closeButton>
                        Exportability
                    </Modal.Header>

                    <Modal.Body>
                        {props.exportabilityResults.length > 0 && (
                            <>
                                <p style={{ fontWeight: 'bold' }}>
                                    This donor is not exportable for the following reason(s):
                                </p>

                                <ul>
                                    {props.exportabilityResults.map((exportabilityResult, index) =>
                                        <li key={index}>{exportabilityResult.toString()}</li>
                                    )}
                                </ul>
                            </>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={props.onCancel}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    if (props.type == 2) {
        return (
            <>
                <Modal show={props.show} onHide={() => null} style={{ zIndex: 999999 }}>
                    <Modal.Header closeButton>
                        Profile Compliance
                    </Modal.Header>

                    <Modal.Body>
                        {props.donorCompliance.complianceIssues.length > 0 && (
                            <>
                                <p style={{ fontWeight: 'bold' }}>
                                    We found the following issues:
                                </p>

                                <ul>
                                    {props.donorCompliance.complianceIssues.map((complianceIssue, index) =>

                                        <li key={index}>{complianceIssue.toString()}</li>
                                    )}
                                </ul>
                            </>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={props.onCancel}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    if (props.type == 3) {
        return (
            <>
                <Modal show={props.show} onHide={() => null} style={{ zIndex: 999999, width: '100%' }}>
                    <Modal.Header closeButton>
                        Voucher Completion
                    </Modal.Header>

                    <Modal.Body>
                        {props.adpVoucherHolders.length > 0 && (
                            <>
                                <p>
                                    The following voucher holders are incomplete. If their consents are not uploaded prior to donation, they will not be eligible for vouchers
                                </p>

                                <Table condensed striped bordered>
                                    <thead>
                                        <tr style={{ backgroundColor: '#337ab7', color: 'white', height: 40, width: 400 }}>
                                            <th style={{ textAlign: 'center' }}>Row</th>
                                            <th style={{ textAlign: 'center' }}>Name</th>
                                            <th style={{ textAlign: 'center' }}>Phone</th>
                                            <th style={{ textAlign: 'center' }}>Donor Type</th>
                                            <th style={{ textAlign: 'center' }}>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody style={{ fontSize: 14, width: 550 }}>
                                        {props.adpVoucherHolders.map((voucherHolder, index) =>
                                            <tr key={index}>
                                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                                <td style={{ textAlign: 'center' }}>{voucherHolder.firstName} {voucherHolder.lastName}</td>
                                                <td style={{ textAlign: 'center' }}>{voucherHolder.phoneNumberPrimary}</td>
                                                <td style={{ textAlign: 'center' }}>{VoucherHolderType[voucherHolder.type]}</td>
                                                <td style={{ textAlign: 'center' }}>{VoucherHolderSelfRegistrationStep[voucherHolder.currentSelfRegistrationStep]}</td>

                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={props.onCancel}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    return null;
}

export default NotificationDetails;